"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deletePuffRecords = exports.createDummyRecords = void 0;
var DeviceCharacteristic_1 = require("../../../common/DeviceCharacteristic");
// eslint-disable-next-line import/prefer-default-export
var createDummyRecords = function (device, value) {
    // const buffer = new ArrayBuffer(10);
    // const values = new Uint8Array(buffer);
    // values.set(Uint8Array.of(value), 3);
    var buffer = new ArrayBuffer(4);
    var values = new DataView(buffer);
    values.setUint32(0, value);
    return device.writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS; })
        .uuid, values.buffer);
};
exports.createDummyRecords = createDummyRecords;
var deletePuffRecords = function (device) {
    var value = 0XFFFFFFFD;
    var buffer = new ArrayBuffer(4);
    var values = new DataView(buffer);
    values.setUint32(0, value);
    return device.writeCharacteristicValues(device.profile.VAPING.characteristics.find(function (c) { return c.name === DeviceCharacteristic_1.VapingCharacteristics.PUFF_RECORDS; })
        .uuid, values.buffer);
};
exports.deletePuffRecords = deletePuffRecords;
